import { useContext } from "react";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import ConversionRate from "components/organisms/ConversionRate/ConversionRate";
import { roundUp } from "helpers/commonHelpers";
import CostFormCalculationContext from "./CostCalculationContext";

function CostFormTotalAmount() {
  const {
    totalFreightCharges,
    calculatingFreightCharges,
    totalOtherCharges,
    calculatingOtherCharges,
    shipperPreferredCurrency,
    getConversionRates,
  } = useContext<any>(CostFormCalculationContext);
  const conversionRates = getConversionRates();

  return (
    <div className="d-flex justify-content-between align-items-start mt-3">
      <div>
        <b>
          <FormattedMessage id="quotation-form.total" defaultMessage="Total" />
        </b>
      </div>
      <div className="d-flex flex-column">
        {calculatingFreightCharges || calculatingOtherCharges ? (
          <div className="skeleton-card" style={{ width: 110 }}>
            <Row className="skeleton-row">
              <span key={6} className="skeleton full" />
            </Row>
          </div>
        ) : (
          <>
            <div className="font-b1 mb-1">
              <FormattedMessage id="quotation-form.totalAmount" defaultMessage="Total amount" />{" "}
              <b>
                {roundUp(+roundUp(totalFreightCharges) + +roundUp(totalOtherCharges))} {shipperPreferredCurrency}
              </b>
            </div>
            {!!conversionRates?.length &&
              conversionRates.map((rates: any, index: number) => {
                const item = {
                  target_currency: rates.currency,
                  base_currency: rates.new_currency,
                  rate: rates.conversion_rate,
                  timestamp: rates.last_updated,
                };
                return <ConversionRate key={index} item={item} _class="mb-xs" />;
              })}
          </>
        )}
      </div>
    </div>
  );
}

export default CostFormTotalAmount;
